import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IBlockoutsState } from './types';
import { IBlockout, ILayout } from 'shared-types/SharedTypes';
import {ReduxSlices} from "floorplan-v2/app/appRoot/types";
// import { loadBookingsFromCurrentSchedule } from 'app/reducers/booking/slice';
import { cloneDeep } from 'lodash-es';
import { FloorplanV2State } from 'floorplan-v2/app/appRoot/rootReducer';

const NS = 'BlockoutsSlice';

const initialState: IBlockoutsState = {
  floorplanBlockouts: [],
  activeAddBlockoutsByTable: false,
  selectedBlockoutsByTable: [],
  blockoutsByTableIdArray: [],
  floorplanBlockoutsForSave: {},
  blockoutsPerTable: {},
};
const getBlockoutsPerTable = (blockouts: IBlockout[], layouts: ILayout[]) => {
  const blockoutsPerTable: {[key: string]: IBlockout[]} = {};
  layouts.forEach((layout) => {
    layout.tables.forEach((tableId) => {
      blockouts.forEach((blockout) => {
        if (blockout.blockedSections.length && blockout.blockedSections.includes(layout.sectionId)) {
          blockoutsPerTable[tableId] ?  blockoutsPerTable[tableId].push(blockout) : blockoutsPerTable[tableId] = [blockout];
        }
        if (blockout.blockedTables.length && blockout.blockedTables.map((value) => value._id).includes(tableId)) {
          blockoutsPerTable[tableId] ?  blockoutsPerTable[tableId].push(blockout) : blockoutsPerTable[tableId] = [blockout];
        }
      });
    });
  });
  return blockoutsPerTable;
}
export const updateFloorplanBlockouts = createAsyncThunk(
  `${ReduxSlices.BlockOuts}/updateFloorplanBlockouts`,
  async (payload: IBlockout[], { dispatch, getState }): Promise<any> => {
    const {
      layoutReducer: { couchReducedLayouts },
    } = getState() as FloorplanV2State;
    const blockoutsPerTable = getBlockoutsPerTable(payload, couchReducedLayouts);
    return {blockoutsPerTable, floorplanBlockouts: cloneDeep(payload)};
  }
);

export const loadFloorplanBlockouts = createAsyncThunk(
  `${ReduxSlices.BlockOuts}/loadFloorplanBlockouts`,
  async (payload: void, { dispatch, getState }): Promise<any> => {
    const {
      scheduleReducer: { selectedSchedule },
      layoutReducer: { couchReducedLayouts },
    } = getState() as FloorplanV2State;
    const blockoutsPerTable = getBlockoutsPerTable(selectedSchedule.blockouts, couchReducedLayouts);
    return {blockoutsPerTable, floorplanBlockouts: cloneDeep(selectedSchedule.blockouts)};
  }
);

const blockOutSlice = createSlice({
  name: ReduxSlices.BlockOuts,
  initialState,
  reducers: {
    setFloorPlanBlockOuts: (state, action: PayloadAction<IBlockout[]>) => {
      console.log(NS, 'setFloorPlanBlockOuts', action);
      state.floorplanBlockouts = action.payload;
    },
    resetFloorPlanBlockOuts: () => {
      return initialState;
    },
    resetActiveAddBlockouts: (state) => {
      state.activeAddBlockoutsByTable = false;
      state.blockoutsByTableIdArray = [];
      state.selectedBlockoutsByTable = [];
      state.floorplanBlockoutsForSave = {};
    },
    setActiveAddBlockoutsByTable: (state, action: PayloadAction<boolean>) => {
      state.activeAddBlockoutsByTable = action.payload;
    },
    setSelectedBlockoutsByTable: (state, action: PayloadAction<{_id: string, name: string}[]>) => {
      state.selectedBlockoutsByTable = action.payload;
      state.blockoutsByTableIdArray = action.payload.map((value) => value._id);
    },
    setBlockoutsByTableIdArray:(state, action: PayloadAction<string[]>) => {
      state.blockoutsByTableIdArray = action.payload;
    },
    setFloorplanBlockoutsForSave: (state, action: PayloadAction<Partial<IBlockout>>) => {
      state.floorplanBlockoutsForSave = action.payload;
    },
    addOrRemoveSelectedBlockoutsByTable: (state, action: PayloadAction<{_id: string, name: string}>) => {
      const _selectedBlockoutsByTable = state.selectedBlockoutsByTable.filter((e) => e._id !== action.payload._id);
      if (_selectedBlockoutsByTable.length !== state.selectedBlockoutsByTable.length) {
        state.selectedBlockoutsByTable = _selectedBlockoutsByTable;
      } else {
        state.selectedBlockoutsByTable.push(action.payload);
      }
      state.blockoutsByTableIdArray = state.selectedBlockoutsByTable.map((e) => e._id);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadFloorplanBlockouts.fulfilled, (state, action) => {
      state.floorplanBlockouts = action.payload.floorplanBlockouts;
      state.blockoutsPerTable = action.payload.blockoutsPerTable;
    });
    builder.addCase(updateFloorplanBlockouts.fulfilled, (state, action) => {
      state.floorplanBlockouts = action.payload.floorplanBlockouts;
      state.blockoutsPerTable = action.payload.blockoutsPerTable;
    });
  },
});

const actions = blockOutSlice.actions;
export { actions as floorplanBlockoutsActions };

export default blockOutSlice.reducer;
